import axios, { AxiosError } from 'axios';

import { User } from '@tassomutuo-backoffice/types';
import { axiosApiInstancePrivate } from '..';

interface UsersResponse {
  results: User[];
  page: number;
  limit: number;
  totalPages: number;
  totalResults: number;
}

export const getUsers = async ({
  page,
  pageSize,
  email = '',
}: {
  page: number;
  pageSize: number;
  email: string;
}): Promise<UsersResponse> => {
  try {
    const params: {
      page: number;
      limit: number;
      email?: string;
      includeProfileCollaboratori: boolean;
      includeBgIntegrityCheck: boolean;
    } = {
      page,
      limit: pageSize,
      includeProfileCollaboratori: true,
      includeBgIntegrityCheck: true,
    };
    if (email) {
      params['email'] = email;
    }
    const response = await axiosApiInstancePrivate.get<UsersResponse>(
      `/v1/users`,
      {
        params,
      }
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const changeCanReceiveLeads = async ({
  userId,
  canReceiveLeads,
}: {
  userId: string;
  canReceiveLeads: boolean;
}) => {
  try {
    const response = await axiosApiInstancePrivate.patch<User>(
      `/v1/users/${userId}`,
      { canReceiveLeads }
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const changeCanReceiveLeadsQuinto = async ({
  userId,
  canReceiveLeadsQuinto,
}: {
  userId: string;
  canReceiveLeadsQuinto: boolean;
}) => {
  try {
    const response = await axiosApiInstancePrivate.patch<User>(
      `/v1/users/${userId}`,
      { canReceiveLeadsQuinto }
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const changeCanReceiveLeadsPrestito = async ({
  userId,
  canReceiveLeadsPrestito,
}: {
  userId: string;
  canReceiveLeadsPrestito: boolean;
}) => {
  try {
    const response = await axiosApiInstancePrivate.patch<User>(
      `/v1/users/${userId}`,
      { canReceiveLeadsPrestito }
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const getMe = async () => {
  try {
    const response = await axiosApiInstancePrivate.get<User>(`/v1/users/me`);
    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};
